import axios from "axios";

const IMPERSONATION_COOKIE_KEY = 'impersonationToken';
const SOURCING_URL = process.env.REACT_APP_SOURCING_API_URL;

// Global axios interceptor - adds impersonation token to ALL requests
// config is used so we can modify the outgoing request (add the impersonation header) before Axios sends it.

const API_HOST = process.env.REACT_APP_API_HOST;

// Send the HttpOnly accessToken cookie on every request to our own backend.
// Set here (loaded very early, before other modules call axios.create()) so
// it's the app-wide baseline; axios.create() instances created after this
// runs inherit it, but see the geniehireadmin/services/*.js files, which set
// it explicitly too rather than relying on import order.
axios.defaults.withCredentials = true;

// The impersonation token is a bearer credential: only send it to our own APIs,
// never to third-party hosts (S3, AssemblyAI, etc.) that axios also calls.
const isFirstPartyApi = (url = "") =>
  (API_HOST && url.startsWith(API_HOST)) || (SOURCING_URL && url.startsWith(SOURCING_URL));

axios.interceptors.request.use((config) => {
  // impersonationToken and the sourcing-API accessToken copy both live in
  // sessionStorage now (never a cookie) -- see the HttpOnly-cookie migration.
  const token = sessionStorage.getItem(IMPERSONATION_COOKIE_KEY);
  if (token && isFirstPartyApi(config.url)) {
    config.headers['X-Impersonation-Token'] = token;
  }

  // Sourcing API is authenticated with the same Cognito access token as GenieHire.
  // Scoped to sourcing-bound requests only — GenieHire call sites already set the
  // Authorization header themselves. The main backend's HttpOnly cookie is scoped
  // to its own domain and is never sent here, so this sessionStorage copy is the
  // only way this call gets authenticated.
  if (SOURCING_URL && config.url && config.url.startsWith(SOURCING_URL)) {
    const accessToken = sessionStorage.getItem('accessToken');
    if (accessToken && !config.headers['Authorization']) {
      config.headers['Authorization'] = `Bearer ${accessToken}`;
    }
  }

  return config;
});
